import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/access_token*',
    name: 'Login',
    component: Login
  },
  {
    path: '/loginError*',
    name: 'Login',
    component: Login
  },
  {
    path: '/code*',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "forgotPassword" */ '../views/forgotPassword.vue')
  },
  {
    path: '/switch/account',
    name: 'switchAccount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "switchAccount" */ '../views/switchAccount.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
